<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="name">Name</label>
        <input type="text" id="name" v-model="$parent.tour.name" required>
      </div>

      <div>
        <label for="reference">Reference</label>
        <input type="text" id="reference" v-model="$parent.tour.reference" required>
      </div>

      <div>
        <label for="tour_status">Status</label>
        <v-select id="tour_status" v-model="$parent.tour.enabled" :options="tour_status" label="label" index="id"/>
      </div>

      <div>
        <label for="tour_type">Tour type</label>
        <v-select id="tour_type" v-model="$parent.tour.tour_type" :options="tour_type" label="label"/>
      </div>

      <div>
        <label for="deposit">Deposit price (£)</label>
        <input id="deposit" type="number" v-model="$parent.tour.deposit_price" required>
      </div>

      <div>
        <label for="duration">Duration (days)</label>
        <input id="duration" type="number" v-model="$parent.tour.duration" required>
      </div>

      <div>
        <label for="minimum-age">Minimum age</label>
        <input id="minimum-age" type="number" v-model="$parent.tour.minimum_age">
      </div>

      <div>
        <label for="release">Release days before</label>
        <input id="release" type="number" v-model="$parent.tour.release_days_before" required>
      </div>

      <div>
        <label for="destination">Destination country</label>
        <v-select id="destination" v-model="$parent.tour.destination" label="name" index="id" :options="countries" ></v-select>
      </div>

      <div>
        <label for="bonding">Bonding type</label>
        <v-select id="bonding" v-model="$parent.tour.bonding_type_id" label="name" index="id" :options="bonding_types"></v-select>
      </div>

      <div>
        <label for="places">Places available</label>
        <input id="places" type="number" v-model="$parent.tour.tour_places" required>
      </div>

      <div>
        <label for="stop-sell">Stop sell</label>
        <label class="switch">
          <input id="stop-sell" type="checkbox" v-model="$parent.tour.stop_sell">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="is_suppressed">Is suppressed?</label>
        <label class="switch">
          <input id="is_suppressed" type="checkbox" v-model="$parent.tour.is_suppressed">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div>
        <label for="is_suppressed">Passport Details Required ?</label>
        <label class="switch">
          <input id="is_suppressed" type="checkbox" v-model="$parent.tour.is_passport_details_required">
          <span class="switch__slider"></span>
        </label>
      </div>

      <div style=" flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);">
        <label for="itinerary">Itinerary Details</label>
        <textarea id="itinerary" style="max-width: 100%; min-height: 8rem" v-model="$parent.tour.itinerary"></textarea>
      </div>

      <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);">
        <label for="covering_emails">Covering Emails</label>
        <textarea id="covering_emails" style="max-width: 100%; min-height: 8rem" v-model="$parent.tour.covering_emails"></textarea>
      </div>
      <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);">
        <label>Tour Information</label>
        <input id="file-upload" type="file" class="form-control" v-on:change="uploadDoc"  accept=".pdf">
      </div>
      <div style="flex-grow: 0; flex-shrink: 0; flex-basis: calc(50% - 1rem);" v-if="$parent.tour.information_doc_name">
        <label>Tour Information Document</label>
        <div class="mt-3"><a href="javascript:void(0);"  v-on:click="documentDownload($parent.tour.id, $parent.tour.information_doc_name)"><b>{{$parent.tour.information_doc_name}}</b></a></div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'TourFields',
  props: {
    countries: {
      type: Array,
      required: false
    },
    bonding_types: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      tour_type: ['air', 'coach', 'self-drive', 'world-wide'],
      tour_status: [
        {
          label: 'Enabled',
          id: 1
        },
        {
          label: 'Disabled',
          id: 0
        }
      ],
    }
  },
  methods: {
    // getCountries () {
    //   this.$store.dispatch('setLoadStatus')
    //   fetch(this.$api + 'countries', {
    //       headers: {
    //         'Accept': 'application/json',
    //         'Authorization': localStorage.getItem('token')
    //       }
    //     })
    //   .then(res => res.json())
    //   .then(response => {
    //     this.countries = response.data
    //     this.$store.dispatch('setLoadStatus')
    //   })
    // },
    // getAccommodation () {
    //   this.$store.dispatch('setLoadStatus')
    //   fetch(this.$api + 'tours/accommodations', {
    //       headers: {
    //         'Accept': 'application/json',
    //         'Authorization': localStorage.getItem('token')
    //       }
    //     })
    //   .then(res => res.json())
    //   .then(response => {
    //     this.accommodations = response.data
    //     this.$store.dispatch('setLoadStatus')
    //   })
    // },
    // getBondingTypes () {
    //   this.$store.dispatch('setLoadStatus')
    //   fetch(this.$api + 'bonding-types', {
    //       headers: {
    //         'Accept': 'application/json',
    //         'Authorization': localStorage.getItem('token')
    //       }
    //     })
    //   .then(res => res.json())
    //   .then(response => {
    //     this.bonding_types = response.data
    //     this.$store.dispatch('setLoadStatus')
    //   })
    // },
    uploadDoc(event) {
      this.$parent.tour.tour_info_doc = event.target.files[0];
    },
    documentDownload(id, filename) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'tours/tours-document/' + id + '/download' , {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then((res) => {
        if(res.status === 200) {
          res.blob().then(response => {
            const _url = window.URL.createObjectURL(response)
            const link = document.createElement('a')
            link.href = _url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click();
          })
        }else {
          this.$notify({
            type: 'error',
            title: 'File not found'
          });
        }
      })
      this.$store.dispatch('setLoadStatus')
    }
  }
}
</script>
